<template>
  <div class="mission">
    <div id="MissionStart pt-5 ">
      <div class="row d-flex justify-content-center mb-sm-5" style="height:60vh">
        <div class=" missionstart col-4 col-sm-4 d-flex justify-content-end align-items-center">
          <div class="missionstartImg">
            <img src="../assets/images/pic_elf_02_L.png" alt="">
          </div>
        </div>
        <div class="col-2 col-sm-2 d-flex align-items-center justify-content-center">
          <div class="text">
            <span>任務1/8</span>
          </div>
        </div>
        <div class="col-4 col-sm-4 d-flex justify-content-start align-items-center">
          <div class="missionstartImg">
            <img src="../assets/images/pic_elf_02_R.png" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <div class="d-flex justify-content-center startbtn">
            <a href="" class="btn">START</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MissionStart',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
  .missionstartImg {
    max-height: 200px;
    max-width: 200px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      object-fit: contain;
      display: block;
    }
  }
  .text {
    span {
    color: #1351a4;
    font-weight: 900;
    font-family: '微軟正黑體';
    line-height: 5em;
    font-size: 2em;
    white-space: nowrap;
    text-align: center;
    }
  }
  @media screen and (max-width: 769px) {
  .missionstartImg {
    max-height: 180px;
    max-width: 180px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      object-fit: contain;
      display: block;
    }
  }
    .text {
      span {
      font-size: 1.5em;
      }
    }
  }
  @media screen and (max-width: 568px) {
  .missionstartImg {
    max-height: 160px;
    max-width: 160px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      object-fit: contain;
      display: block;
    }
  }
    .text span {
      font-size: 1.2em;
    }
  }
  .startbtn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
      // margin: 200px 0 0 0;
    .btn {
      padding: 10px 40px;
      border-radius: 5px;
      font-weight: bold;
      text-decoration: none;
    }
  }
</style>
